
export enum LengthUomCd {
	FEET = 'Feet',
	INCHES = 'Inches',
	METERS = 'Meters'}

